import * as angular from "angular";

angular
  .module('bringoz.admin.workload')
  .config(WorkloadConfig);

/* @ngInject */
function WorkloadConfig($stateProvider) {
  $stateProvider

}
